import React, { createContext, useContext, useEffect, useState } from 'react';
import { useFetch } from '@services/useFetch/useFetch';

export interface LeadType {
  id: string;
  pipefyId: string | null;
  leadType: number;
  leadTypeLabel: string;
  lastStep: string | null;
  createdAt: string;
  name: string;
  email: string;
  firstCityChosen: {
    id: string;
    name: string;
    state: {
      id: string;
      abbreviation: string;
      name: string;
    };
  };
  phone: string;
  onboardingInitialized: boolean;
  onboardingFinished: boolean;
  onboardingScreened: boolean;
}

const LeadContext = createContext<ReturnType<typeof createLeadsData> | null>(null);
const createLeadsData = () => {
  const [lead, setLead] = useState<LeadType>();
  const { data: leadsData, doFetch: getLeads, isFetching: isFetchingLead } = useFetch<LeadType[]>('leads', 'get', { overrideError: true });

  useEffect(() => {
    getLeads();
  }, []);

  const firstLeadIfHasLeads = leadsData?.length === 1 ? leadsData[0] : undefined;

  return {
    leads: leadsData || [],
    lead: lead || firstLeadIfHasLeads,
    isFetchingLead,
    setLead,
  };
};

const LeadProvider = ({ children }) => {
  const leadsData = createLeadsData();
  return <LeadContext.Provider value={leadsData}>{children}</LeadContext.Provider>;
};

function useLeadContext() {
  const context = useContext(LeadContext);
  if (!context) {
    throw new Error('useLeadContext must be used within an LeadProvider.');
  }

  return context!;
}

export { LeadProvider, useLeadContext, LeadContext };
